/**
 * PRASI LABS — Single source of truth for all company information.
 * Update this file to reflect any changes to company details.
 * Imported by: PublicLayout, Login, Sidebar, Navbar, Contact, About, Home, pdfGenerator
 */

export const COMPANY = {
  name:      'PRASI LABS Private Limited',
  shortName: 'PRASI LABS',
  tagline:   'Custom Synthesis, Drug Impurities & Stable Isotopes Supplier',
  description:
    "Specialized in Custom Synthesis and Rare Impurities — India's trusted supplier of pharmaceutical drug impurities, stable isotope-labelled compounds, and custom synthesis solutions — serving global pharma and CRO clients since 2021.",

  address: {
    line1:   'Plot No 23 & 24, TSIIC Extn, Shaktipuram',
    line2:   'Prashanthi Nagar, IDA Kukatpally',
    city:    'Hyderabad',
    state:   'Telangana',
    pin:     '500072',
    country: 'INDIA',
    full:    'Plot No 23 & 24, TSIIC Extn, Shaktipuram, IDA Kukatpally, Prashanthi Nagar, Hyderabad-500072, Telangana, INDIA',
    oneLine: 'Plot No 23 & 24, Shaktipuram, Kukatpally, Hyderabad – 500072, INDIA',
  },

  phone:   '+91-9160006515',
  email:   'info@prasilabs.com',
  website: 'www.prasilabs.com',

  gstin:     '36AALCP8001G1Z6',
  cin:       'U24290TG2021PTC148865',
  iec:       'AALCP8001G',
  pan:       'AALCP8001G',
  msme:      'UDYAM-TS-09-0012881',
  lut:       'AD3603250364538',
  lutDate:   '22.03.2025',
  stateCode: '36',
  state:     'Telangana',

  bank: {
    name:    'IDFC FIRST BANK',
    account: '10068649634',
    ifsc:    'IDFB0080222',
    branch:  'HITECH CITY',
  },

  insurance: {
    policy:  'OG-21-1933-1005-00000012',
    type:    'Marine Cargo Insurance',
    company: 'Bajaj Allianz',
  },

  paymentLink: 'https://pay.prasilabs.com/invoice/',

  founded:    '2021',
  crmVersion: 'v2.0',

  social: {
    linkedin:  'https://www.linkedin.com/company/prasi-labs',
    whatsapp:  'https://wa.me/919160006515',
  },

  hours: 'Mon – Sat  9:30 AM – 6:00 PM IST',

  services: [
    'Drug Impurities',
    'Stable Isotopes',
    'Reference Standards',
    'Custom Synthesis',
    'Contract R&D',
    'CDMO Services',
  ],
};
